import { Component, computed, inject, ChangeDetectionStrategy } from "@angular/core";
import { UtilityService } from "@eforall/common";
import { GoalDetailsDialogDataService } from "../goal-details-dialog-data.service";

@Component({
	selector: 'goal-details-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './details.part.html'
})
export class GoalDetailsPart {

	private readonly util = inject(UtilityService);
	public readonly dialogDataService = inject(GoalDetailsDialogDataService);

	public goalDetails = computed(() => {
		const goal = this.dialogDataService.goalDetails();
		if (!goal) return undefined;

		const commentsMap = this.util.array.toArrayMap(goal.comments, c => c.commentType);

		const latestProgressUpdatedUTC = commentsMap['Progress'] ? Math.max(...commentsMap['Progress'].map(c => c.updatedUTC)) : undefined;

		return {
			...goal,
			commentsCountMap: {
				progress: commentsMap['Progress']?.length ?? 0,
				mentor: commentsMap['Mentor']?.length ?? 0,
				staff: commentsMap['Staff']?.length ?? 0,
			},
			latestProgressDate: latestProgressUpdatedUTC ? this.util.date.formatUTC(latestProgressUpdatedUTC, 'MMM D, YYYY', 'H:MM AM EST', 'en-US') : 'No Progress',
			formattedCreatedDate: this.util.date.formatUTC(goal.createdUTC, 'MMM D, YYYY', 'H:MM AM EST', 'en-US'),
			formattedUpdatedDate: this.util.date.formatUTC(goal.updatedUTC, 'MMM D, YYYY', 'H:MM AM EST', 'en-US')
		};
	})
}